import * as React from "react";

function SvgHeading1(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}><path d="M8.5 13H5.8V8.9H2.7V13H0V3h2.7v3.7h3.1V3h2.7v10zM16 13h-2.7V7.7 5.9c-.2.2-.4.4-.6.7l-1.1.9-1.4-1.7L13.6 3H16v10z" /></svg>;
}

export default SvgHeading1;